//TODO: Move to Checkout Core

import React, { memo, ReactElement, useMemo } from "react";

//constants
import { CART_TIMER_TEST_IDS, RESTAURANT_CLOSE_TEXT } from "@core-ui/constants/TimerOnCart";

//components
import { OverflowHidden } from "@core-ui/components/index";
import { CroutonTimer } from "@core-ui/components/crouton-timer";
import { Portal } from "@swiggy-private/dls-web-core/dist/components/Portal";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import { default as InfoFilledIcon } from "@swiggy-private/dls-web-icons/dist/web/generic/infoFilled/20";
import { TimerCroutonWrapper, TimerCroutonContent, TimerCroutonIconContainer, TimerCroutonText } from "./styles";

export interface CartTimerProps {
    duration: number;
    source?: string;
    onComplete: () => void;
    onTimerLoad: () => void;
}

const CartTimer = (props: CartTimerProps): ReactElement => {
    const { duration, source, onTimerLoad, onComplete } = props;

    //TODO:Break this Component when moving to checkout core
    const TimerComponent = useMemo(
        () => (
            <TimerCroutonWrapper source={source} data-testid={CART_TIMER_TEST_IDS.CART_TIMER_WRAPER}>
                <TimerCroutonContent>
                    <TimerCroutonIconContainer>
                        {/* TODO: @HIMANSHU: finalise icon color with design*/}
                        <GenericIcon Icon={InfoFilledIcon} fillColor="negative" strokeColor="negative" />
                    </TimerCroutonIconContainer>
                    {/* TODO: @HIMANSHU: finalise text variant and color with design*/}
                    <TimerCroutonText variant="V2.body3.neutral.regular" color="background_Primary">
                        {RESTAURANT_CLOSE_TEXT}
                    </TimerCroutonText>
                    <CroutonTimer duration={duration} onTimerLoad={onTimerLoad} onComplete={onComplete} />
                </TimerCroutonContent>
            </TimerCroutonWrapper>
        ),
        [duration, onComplete, onTimerLoad, source],
    );

    return (
        <Portal>
            <OverflowHidden>{TimerComponent}</OverflowHidden>
        </Portal>
    );
};
export default memo(CartTimer);
